<template>
<div class="pkami">
    <div class="brief-bg">
        <div class="brief-bg__word" :style="briefwordstyle">
            <h2 class="fadeInUp">电子卡密</h2>
            <span class="fadeInUp">
                    提供虚拟商品的发售服务，添加卡密数据，发售卡密商品
                </span>
        </div>
        <img src="/site_static/pimg/product-card.png" alt="" :style="briefimg">
    </div>
    <div  class="itemOne">
        <div  class="itemHeader">
            <p class="itemHeaderTitle">您身边的电子卡密</p>
        </div>
        <img class="itemImg"  src="/site_static/pimg/card-serve1.png" >
    </div>
    <div style="background: #e3f2fd;">
        <mu-carousel hide-controls>
            <mu-carousel-item>
                <p class="lunp">高度灵活的卡密库设置</p>
                <p class="lunp1">可设置不同的卡密分类，设置多规格卡密库，自定义名称，卡密库设置灵活多变，满足您的多样性需求。</p>
                <img style="margin-top:3rem;width: 80%" src="/site_static/pimg/cm_function01.png">
            </mu-carousel-item>
            <mu-carousel-item>
                <p class="lunp">高度灵活的卡密库设置</p>
                <p class="lunp1">可设置不同的卡密分类，设置多规格卡密库，自定义名称，卡密库设置灵活多变，满足您的多样性需求。</p>
                <img style="margin-top:3rem;width: 80%" src="/site_static/pimg/cm_function02.png">
            </mu-carousel-item>
            <mu-carousel-item>
                <p class="lunp">高度灵活的卡密库设置</p>
                <p class="lunp1">可设置不同的卡密分类，设置多规格卡密库，自定义名称，卡密库设置灵活多变，满足您的多样性需求。</p>
                <img style="margin-top:3rem;width: 80%" src="/site_static/pimg/cm_function03.png">
            </mu-carousel-item>
            <mu-carousel-item>
                <p class="lunp">高度灵活的卡密库设置</p>
                <p class="lunp1">可设置不同的卡密分类，设置多规格卡密库，自定义名称，卡密库设置灵活多变，满足您的多样性需求。</p>
                <img style="margin-top:3rem;width: 80%" src="/site_static/pimg/cm_function04.png">
            </mu-carousel-item>
        </mu-carousel>
    </div>
    <div style="background: #ffcdd2">
        <mu-carousel  hide-controls>
            <mu-carousel-item>
                <p class="lunp">人性化的用户体验</p>
                <p class="lunp1">用户完成订单，可在发货信息中，使用一键复制按钮复制所需卡密，操作方便，提高用户满意度 。</p>
                <img style="margin-top:3rem;width: 80%" src="/site_static/pimg/function05.png">
            </mu-carousel-item>
            <mu-carousel-item>
                <p class="lunp">贴心的提示说明</p>
                <p class="lunp1">针对卡密库可设置使用说明，用户完成订单，可在订单详情页查看使用说明，节约您的沟通时间。</p>
                <img style="margin-top:3rem;width: 80%" src="/site_static/pimg/function06.png">
            </mu-carousel-item>
            <mu-carousel-item>
                <p class="lunp">更安全的发货方式</p>
                <p class="lunp1">自动发货后卡密直接绑定在订单里，用户无法删掉，方便用户随时查询使用。</p>
                <img style="margin-top:3rem;width: 80%" src="/site_static/pimg/function07.png">
            </mu-carousel-item>
        </mu-carousel>
    </div>
    <div class="fooder">
        <div class="logo">
            <img src="../../../assets/phoneimg/nav_logo.png" alt="">
        </div>
        <div class="body">
            <ul>
                <li>国际顶级域名</li>
                <li>出版物经营许可证</li>
                <li>广播电视节目制作经营许可证</li>
                <li>开户许可证</li>
                <li>食品经营许可证</li>
                <li>计算机软件著作权证书</li>
                <li>网络文化经营许可证</li>
                <li>营业执照</li>
                <li>增值电信业务许可证</li>
            </ul>
        </div>
        <div class="last">
            <span>微涟科技有限公司版权所有</span>
            <span>©辽ICP备18009739号</span>
        </div>
    </div>
</div>
</template>
<script>
    export default {
        name: 'pkami',
        data(){
            return{
                briefwordstyle:{},
                briefimg:{},
                pageh:{},
                active: 0
            }
        },
        created() {
            let self = this
            setTimeout(function () {
                self.briefwordstyle={
                    opacity: 1,
                    bottom: '3rem'
                }
                self.briefimg={
                    opacity: 1,
                    bottom: '1rem'
                }
                self.pageh={
                    opacity: 1,
                    bottom: 0
                }
            },0)
        },
        methods: {
            changeActive (index) {
                this.active = index;
            }
        }
    }
</script>
<style scoped>
    ul{
        list-style: none;
        padding: 0;
    }
    .pkami{
        margin-top: 3rem;
    }
    .brief-bg{
        width: 100%;
        height: 10.9375rem;
        position: relative;
        background: linear-gradient(90deg,#ff8b54,#ff5870);
        overflow: hidden;
    }
    .brief-bg>.brief-bg__word{
        position: absolute;
        width: 11.25rem;
        left: 1.25rem;
        bottom: 0rem;
        color: #fff;
        opacity: 0;
        transition: all .5s;
    }
    .brief-bg>.brief-bg__word>h2{
        line-height: 1.125rem;
        font-weight: 600;
        font-size: 1.125rem;
        color: #fff;
        margin-bottom: 1.25rem;
    }
    .brief-bg>.brief-bg__word>span {
        font-size: .75rem;
        color: hsla(0,0%,100%,.8);
        line-height: 1.3125rem;
    }
    .brief-bg>img{
        width: 8.0625rem;
        position: absolute;
        bottom: 0rem;
        right: 1.25rem;
        opacity: 0;
        transition: all .5s;
    }
    .page-info{
        width: 100%;
        position: relative;
        overflow: hidden;
    }
    .page-info>h2{
        margin: 2.5rem auto .4375rem;
        text-align: center;
        font-size: 1.0625rem;
        font-weight: 600;
        line-height: 1.0625rem;
        color: #5d6494;
        position: relative;
        bottom: -2rem;
        transition: all .5s;
        opacity: 0;
    }
    .page-info>h3{
        width: 18.6875rem;
        margin: auto;
        text-align: center;
        font-size: .75rem;
        line-height: 1.3125rem;
        color: #9c9eae;
        font-weight: 400;
        position: relative;
        bottom: -2rem;
        transition: all 1s;
    }
    .itemOne {
        padding-top: 2.5rem;
        padding-bottom: 1.4375rem;
        min-height: 18.75rem;
    }
    .itemHeader>.itemHeaderTitle {
        font-size: 1.125rem;
        text-align: center;
        color: #5d6494;
        font-weight: 600;
    }
    .itemOne .itemImg {
        margin-top: 1.5rem;
        max-width: 100%;
    }
    .lunp{
        font-size: 1.125rem;
        text-align: center;
        color: #5d6494;
        font-weight: 600;
    }
    .lunp1{
        margin: 0 auto;
        margin-top: .625rem;
        font-size: .69rem;
        color: #7b88a2;
        width: 80%;
        position: relative;
        z-index: 2;
    }
    .fooder{
        width: 100%;
        overflow: hidden;
        background: #1c1c24;
        position: relative;
    }
    .logo{
        width: 20.9375rem;
        margin: auto;
        height: 4.96875rem;
        position: relative;
        margin-left: 2rem;
    }
    .logo>img{
        width: 14.25rem;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        height: auto;
    }
    .body{
        width: 100%;
        box-sizing: border-box;
        margin: auto;
    }
    .body>ul{
        width: 100%;
        margin-bottom: 1.5rem;
        overflow: hidden;

    }
    .body li{
        margin: 0 1.1875rem 0 0;
        font-size: .75rem;
        color: #888;
        line-height: .75rem;
        width: calc(33% - 1rem);
        float: left;
        margin:  .5rem;
    }
    .last{
        width: 20.9375rem;
        margin: auto;
        height: 4.125rem;
        box-sizing: border-box;
        border-top: 1px solid hsla(0,0%,100%,.1);
        padding: 1.125rem 0 0 0;
        margin-bottom: 3rem;
    }
    .last>span{
        display: block;
        font-size: .625rem;
        color: #3d404d;
        line-height: 1rem;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/phone/ppro/pkami.vue